import FullPageLoader from "components/fullPageLoader"
import React, { useState } from "react"
import { useEffect } from "react"
import { Container, Nav, NavItem, NavLink } from "reactstrap"
import DocumentSearchResult from "./documentSearchResult"
import FaqSearchResult from "./faqSearchResult"
import InvestmentVideoSearch from "./investmentVideoSearch"
import IcdSearchResult from "./icdSearchResult"
import NewAndUpdates from "./newAndUpdates"
import ProfileSearchResult from "./profileSearchResult"
import NoDataFound from "components/Common/NoDataFound"
import {
  useLazyInvestorGlobalSeachQuery,
  useLazyWpGlobalSeachQuery,
} from "store/api/investorapi/auth.api"
import { formatName } from "helpers/utils"
import AboutIcd from "./aboutIcd"
import AboutUs from "./aboutUs"
import TDSReports from "./tdsReports"
import UserSearchResults from "./userSearchResults"
import HelpRequestsSearchResults from "./helpRequestsSearchResults"
import InvestmentScheduleSearchResults from "./investmentScheduleSearchResults"
import SigningRequestsSearchResults from "./signingRequestsSearchResults"
import { useSelector } from "react-redux"

const InvestorSearch = ({ query, closeModel }) => {
  const [trigger, { isFetching }] = useLazyInvestorGlobalSeachQuery()
  const [triggerWp, { isFetching: isLoading }] = useLazyWpGlobalSeachQuery()
  const [tabData, setTabData] = useState([])
  const [selectedData, setSelectedData] = useState(null)
  const [isData, setIsData] = useState(true)
  const { userType } = useSelector((state) => state.user)

  const handleTransformData = (data) => {
    const keys = Object.keys(data)
    if (keys.length > 0) {
      const transformedData = keys.map((item, index) => {
        const active = index === 0

        switch (item) {
          case "faqs": {
            return {
              type: "nav",
              title: "FAQS",
              active,
              key: item,
              data: data[item],
            }
          }
          case "documents": {
            return {
              type: "nav",
              title: "Documents",
              active,
              key: item,
              data: data[item],
            }
          }

          case "videos": {
            return {
              type: "nav",
              title: "Videos",
              active,
              key: item,
              data: data[item],
            }
          }
          case "newsAndUpdate": {
            return {
              type: "nav",
              title: "News And Updates",
              active,
              key: item,
              data: data[item],
            }
          }
          case "aboutIcdDetails": {
            return {
              type: "nav",
              title: "About ICD",
              active,
              key: item,
              data: data[item],
            }
          }

          case "aboutUsDetails": {
            return {
              type: "nav",
              title: "About Us",
              active,
              key: item,
              data: data[item],
            }
          }

          case "profile": {
            return {
              type: "nav",
              title: "Profile",
              active,
              key: item,
              data: data[item],
            }
          }

          case "icds": {
            return {
              type: "nav",
              title: "ICDS",
              active,
              key: item,
              data: data[item],
            }
          }

          case "tdFiles": {
            return {
              type: "nav",
              title: "TDS Certificates",
              active,
              key: item,
              data: data[item],
            }
          }

          case "soaFiles": {
            return {
              type: "nav",
              title: "Account Statements",
              active,
              key: item,
              data: data[item],
            }
          }

          case "investerUsers": {
            return {
              type: "nav",
              title: userType === "INVESTOR" ? "Users" : "Investors",
              active,
              key: item,
              data: data[item],
            }
          }

          case "supportQueries": {
            return {
              type: "nav",
              title: "Help",
              active,
              key: item,
              data: data[item],
            }
          }

          case "investmentSchedules": {
            return {
              type: "nav",
              title: "Investment Schedules",
              active,
              key: item,
              data: data[item],
            }
          }

          case "signingRequests": {
            return {
              type: "nav",
              title: "Signing Requests",
              active,
              key: item,
              data: data[item],
            }
          }
        }
      })

      setSelectedData({
        ...transformedData[0],
        dataType: transformedData[0].key,
      })

      setIsData(true)
      setTabData(transformedData)
    } else {
      setIsData(false)
      setTabData([])
      setSelectedData(null)
    }
  }

  const handleSearch = async () => {
    try {
      const { success, data } =
        userType === "INVESTOR"
          ? await trigger({ query }).unwrap()
          : await triggerWp({ query }).unwrap()
      if (success) {
        handleTransformData(data)
      }
    } catch (error) {
      setIsData(false)
      setTabData([])
      setSelectedData(null)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearch()
    }, 300)

    return () => clearTimeout(timer)
  }, [query])

  const handleChangeTab = (item, tabType) => {
    if (tabType === "tab") {
      setSelectedData({ ...item, dataType: item.key })
      setTabData((prev) =>
        prev.map((tab) => {
          if (tab.type === "nav")
            return { ...tab, active: item.key === tab.key }
        })
      )
    }
  }

  const renderTabTypes = (item, tabType) => {
    if (item.type === "nav")
      return (
        <NavItem onClick={() => handleChangeTab(item, tabType)}>
          <NavLink className="search-tab" active={item.active}>
            {tabType === "subTab" ? formatName(item.title) : item.title}
          </NavLink>
        </NavItem>
      )
  }

  const renderTabs = (tabType) => {
    if (tabType == "tab")
      return tabData.map((item, index) => (
        <div key={`search_tab_${index}`}>{renderTabTypes(item, tabType)}</div>
      ))
  }

  return (
    <Container>
      {isFetching && <FullPageLoader />}

      {!isFetching && isData && tabData.length > 0 && (
        <>
          <div className="mb-2 search-nav-tab">
            <Nav pills>{renderTabs("tab")}</Nav>
          </div>
          <div style={{ marginTop: "40px" }}>
            {selectedData && selectedData.dataType === "faqs" && (
              <FaqSearchResult data={selectedData} />
            )}

            {selectedData && selectedData.dataType === "videos" && (
              <InvestmentVideoSearch data={selectedData} />
            )}

            {selectedData && selectedData.dataType === "icds" && (
              <IcdSearchResult data={selectedData} close={closeModel} />
            )}

            {selectedData && selectedData.dataType === "newsAndUpdate" && (
              <NewAndUpdates data={selectedData} close={closeModel} />
            )}

            {selectedData && selectedData.dataType === "aboutIcdDetails" && (
              <AboutIcd data={selectedData} close={closeModel} query={query} />
            )}
            {selectedData && selectedData.dataType === "aboutUsDetails" && (
              <AboutUs data={selectedData} close={closeModel} query={query} />
            )}

            {selectedData && selectedData.dataType === "documents" && (
              <DocumentSearchResult data={selectedData} />
            )}

            {selectedData && selectedData.dataType === "tdFiles" && (
              <TDSReports data={selectedData} title="TDS Certificates" />
            )}

            {selectedData && selectedData.dataType === "soaFiles" && (
              <TDSReports data={selectedData} title="Account Statements" />
            )}

            {selectedData && selectedData.dataType === "investerUsers" && (
              <UserSearchResults data={selectedData?.data} close={closeModel} />
            )}

            {selectedData && selectedData.dataType === "supportQueries" && (
              <HelpRequestsSearchResults
                data={selectedData?.data}
                close={closeModel}
              />
            )}

            {selectedData &&
              selectedData.dataType === "investmentSchedules" && (
                <InvestmentScheduleSearchResults data={selectedData?.data} />
              )}

            {selectedData && selectedData.dataType === "signingRequests" && (
              <SigningRequestsSearchResults data={selectedData?.data} />
            )}

            {selectedData && selectedData.dataType === "profile" && (
              <ProfileSearchResult
                data={selectedData?.data}
                query={query}
                close={closeModel}
              />
            )}
          </div>
          {/* </Row> */}
          {/* </CardBody> */}
          {/* // </Card> */}
        </>
      )}
      {!isData && !isFetching && tabData.length === 0 && <NoDataFound />}
    </Container>
    // </div>
  )
}

export default InvestorSearch
